import { z } from 'zod';
import { checkoutResource } from '@/api/resources';

export const flowStateSchema = z.object({
	id: z.string(),
	checkout: checkoutResource,
	// UI-only intent flag (#4737): true once the guest deliberately changed the number of
	// rooms, so changing the persons count no longer auto-overrides their choice.
	roomsTouchedByUser: z.boolean(),
});

export type FlowStoreState = z.infer<typeof flowStateSchema>;
